import { useState } from 'react';
import BreadcrumbWrapper from '../../components/BreadcrumbWrapper';
import Loader from '../../components/Loader';
import Dashboard from '../../components/Dashboard';
import { Tabs, TabsList, TabsTrigger } from '../../components/Tabs/index';

const Insights = () => {
  const [selectedTab, setSelectedTab] = useState('clubMember');
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper crumbArray={[]} />

      <Tabs defaultValue={selectedTab} onValueChange={setSelectedTab}>
        <TabsList>
          <TabsTrigger
            value="clubMember"
            className="border-b-4 data-[state=active]:border-yellow-500 data-[state=inactive]:border-transparent"
          >
            Club Member Insights
          </TabsTrigger>

          <TabsTrigger
            value="guest"
            className="border-b-4 data-[state=active]:border-yellow-500 data-[state=inactive]:border-transparent"
          >
            Guest Insights
          </TabsTrigger>

          <TabsTrigger
            value="restaurant"
            className="border-b-4 data-[state=active]:border-yellow-500 data-[state=inactive]:border-transparent"
          >
            Restaurant Insights
          </TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="flex w-full items-center justify-between">
        <div className="flex w-1/3"></div>

        <div className="flex w-1/3">{isLoading && <Loader />}</div>
      </div>

      <div className={selectedTab === 'clubMember' ? 'block' : 'hidden'}>
        <Dashboard type={'clubMembers'} setIsLoading={setIsLoading} />
      </div>

      <div className={selectedTab === 'guest' ? 'block' : 'hidden'}>
        <Dashboard type={'guests'} setIsLoading={setIsLoading} />
      </div>

      <div className={selectedTab === 'restaurant' ? 'block' : 'hidden'}>
        <Dashboard type={'restaurants'} setIsLoading={setIsLoading} />
      </div>
    </div>
  );
};

export default Insights;
